/// <amd-module name="Build/Admin/Pool/Colors" />

export const ConcurrencyColorPalette = "#a6a6a6";

export const RunningJobsColorPalette = "#0078d4";

export const QueuedJobsColorPalette = "#f58b1f";

export const TopPipelinesColorPalette = "#6b4c9a";

export const PoolGraphGradientColorPalette = "#000000";
